import { render, staticRenderFns } from "./Stockouts.vue?vue&type=template&id=cdee9070"
import script from "./Stockouts.vue?vue&type=script&lang=js"
export * from "./Stockouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports